import i18n from "@/i18n";
import $ from 'jquery';
import VueSlickCarousel from 'vue-slick-carousel'
import PlainTitleText from "@/components/plainTitleText/PlainTitleText.vue";
import Card from "@/components/card/Card.vue";


export default {
    name: "CorrelatedProjects",
    props: {
        correlatedProjects: {}
    },
    data() {
        return {
            projects: null,
            carouselSettings: {
                arrows: true,
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            dots: true,
                            arrows: false,
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true,
                            arrows: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
        }
    },
    mounted() {
        this.projects = this.correlatedProjects.map(correlated => {
            return {
                contents: i18n.t('projects.' + correlated.id),
                geography: correlated.geography
            }
        })
    },
    methods: {
        goToProjectDetail(projectId) {
            this.$router.push({
                name: 'projectDetail',
                params: {projectId: projectId.toLowerCase()}
            })
            location.reload();
        }
    },
    components: {
        VueSlickCarousel,
        PlainTitleText,
        Card
    }

};
